export default __webpack_public_path__ + "static/media/WHITTIER DISTRIC LOGO_outlined-01.df4ec68d.jpg";